<template>
  <div>
      <b-table
          :data="data"
          :loading="loading"
          narrowed
          striped

          paginated
          :per-page="20"
      >

          <template slot-scope="props">
              <b-table-column field="id" label="ID" numeric sortable>
                  {{ props.row.id }}
              </b-table-column>
              <b-table-column field="iconUrl" label="" :width="50">
                  <img class="image is-32x32" :src="props.row.iconUrl" alt="Item icon">
              </b-table-column>
              <b-table-column field="name" label="Name" sortable>
                  {{ props.row.name }}
              </b-table-column>
          </template>
      </b-table>
  </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'items',
        data() {
            return {
                data: [],
                loading: false
            }
        },
        methods: {
            loadAsyncData() {
                this.loading = true;
                axios.get("/database/items").then(response =>
                {
                    this.data = response.data;
                }).catch(error => {
                    this.data = [];
                    throw error;
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        mounted() {
            this.loadAsyncData();
        }
    }
</script>
